// src/firebase.js

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCo3rNMdJBhUr049LBki1JMNoV5C2oieGU",
  authDomain: "xl-labs.firebaseapp.com",
  projectId: "xl-labs",
  storageBucket: "xl-labs.appspot.com",
  messagingSenderId: "56297771971",
  appId: "1:56297771971:web:aed8c26ca56e6defcae376",
  measurementId: "G-VDB6FZMMX6"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);

export default app;